import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

function SupportAccessLinkModal({
  inviteUrl,
  onClose,
}) {
  const { t } = useTranslation();
  const inputRef = useRef(null);
  const [copyStatus, setCopyStatus] = useState('');

  const selectInviteUrl = () => {
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  };

  const copyInviteUrl = async () => {
    setCopyStatus('');

    if (typeof navigator !== 'undefined' && navigator?.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(inviteUrl);
        setCopyStatus('success');
        return;
      } catch {
        // Fall back to selecting the one-time link for legacy or restricted browser contexts.
      }
    }

    selectInviteUrl();

    try {
      if (typeof document !== 'undefined' && document.execCommand('copy')) {
        setCopyStatus('success');
        return;
      }
    } catch {
      // Show the manual-copy message below.
    }

    setCopyStatus('error');
  };

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{t('systemUsers.supportInviteTitle')}</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <p className="text-muted small mb-3">{t('systemUsers.supportInviteHelp')}</p>
              <div className="input-group">
                <input
                  ref={inputRef}
                  className="form-control"
                  value={inviteUrl}
                  readOnly
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={copyInviteUrl}
                >
                  {t('systemUsers.copyInviteLink')}
                </button>
              </div>
              {copyStatus === 'success' ? (
                <div className="text-success small mt-2">{t('systemUsers.copyInviteSuccess')}</div>
              ) : null}
              {copyStatus === 'error' ? (
                <div className="text-danger small mt-2">{t('systemUsers.copyInviteError')}</div>
              ) : null}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-default" onClick={onClose}>{t('common.close')}</button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default SupportAccessLinkModal;
